module.exports = __webpack_public_path__ + "img/img4.04d3c4f3.png";